<!-- Soft Purge Confirmation Modal -->
<!-- Modal Header -->
<div class="modal-header border-0 align-items-center px-4 pt-4 pb-2">
    <h5 class="modal-title text-danger d-flex align-items-center gap-3 m-0">
        <div class="modal-icon-tile bg-danger-subtle text-danger">
            <i class="ri-delete-bin-6-line"></i>
        </div>
        <span class="fs-5 fw-semibold">
            {{ config?.title }}
        </span>
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()">
    </button>
</div>

<hr class="my-2 mx-4">

<!-- Modal Body -->
<div class="modal-body py-4 px-4">
    <!-- Danger Alert -->
    <div class="alert alert-danger d-flex align-items-start mb-4">
        <i class="ri-error-warning-line fs-4 me-3 mt-1"></i>
        <div>
            <h6 class="alert-heading fw-bold mb-2">{{ config?.dangerTitle || ('SOFT_PURGE.DANGER_TITLE' | translate) }}</h6>
            <p class="mb-0">
                {{ config?.dangerMessage || ('SOFT_PURGE.DANGER_MESSAGE' | translate) }}
            </p>
            <ul class="mb-0 mt-2">
                @for (item of config?.purgeItems; track item) {
                    <li>{{ item }}</li>
                }
            </ul>
        </div>
    </div>

    <!-- Bank Account Details Card -->
    <div class="op-card mx-auto mb-4" style="max-width: 450px;">
        <div class="op-card-head danger-head">
            <i class="ri-bank-line"></i>
            <h5 class="fw-bold mb-0">{{ 'SOFT_PURGE.BANK_ACCOUNT_DETAILS' | translate }}</h5>
        </div>
        <div class="op-card-body">
            <div class="mb-3 d-flex align-items-center justify-content-between">
                <div class="text-start">
                    <span class="field-label">{{ 'SOFT_PURGE.ACCOUNT_NAME' | translate }}</span>
                    <p class="fw-bold text-dark fs-5 mb-0">{{ config?.bankAccountDetails?.accountName }}</p>
                </div>
                <div class="d-flex flex-column align-items-end">
                    <img [src]="config?.bankAccountDetails?.bankLogoUrl" alt="bank logo"
                        class="bank-logo mb-1 object-cover">
                    <div class="text-end small text-secondary bank-name">
                        {{ config?.bankAccountDetails?.bankName }}
                    </div>
                </div>
            </div>

            <hr class="my-3 opacity-25">
            <div class="detail-row">
                <span class="text-secondary">{{ 'SOFT_PURGE.ACCOUNT_ID' | translate }}</span>
                <span class="fw-semibold text-dark">{{ config?.bankAccountDetails?.accountId }}</span>
            </div>
            <div class="detail-row">
                <span class="text-secondary">{{ 'SOFT_PURGE.ALIAS' | translate }}</span>
                <span class="fw-semibold text-dark">{{ config?.bankAccountDetails?.alias }}</span>
            </div>
            <div class="detail-row">
                <span class="text-secondary">{{ 'SOFT_PURGE.ACCOUNT_NUMBER' | translate }}</span>
                <span class="fw-semibold text-dark">{{ config?.bankAccountDetails?.accountNumber | numberMaskPipe:4 }}</span>
            </div>
        </div>
    </div>

    <!-- Confirmation Input -->
    <div [formGroup]="confirmationForm" class="confirm-gate danger">
        <div class="gate-head">
            <i class="ri-shield-keyhole-line"></i>
            <span>
                {{ 'SOFT_PURGE.CONFIRMATION_LABEL' | translate }} "<strong>{{ expectedConfirmationText }}</strong>" {{ 'SOFT_PURGE.TO_CONFIRM' | translate }}
            </span>
        </div>
        <input type="text" id="softPurgeConfirmationInput" formControlName="confirmationInput"
            class="form-control gate-input"
            [class.is-invalid]="showValidationError"
            [placeholder]="expectedConfirmationText" />
        @if (showValidationError) {
            <div class="invalid-feedback d-block">
                {{ 'SOFT_PURGE.VALIDATION_ERROR' | translate }}
            </div>
        }
    </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer py-3 bg-light justify-content-end">
    <button (click)="onCancel()" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
        {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button (click)="onConfirm()"
        [disabled]="isProcessing || !isConfirmationValid"
        type="button" class="btn btn-danger px-32">
        @if (isProcessing) {
            <div class="d-flex align-items-center">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <span>{{ 'COMMON.PROCESSING' | translate }}</span>
            </div>
        } @else {
            {{ config?.confirmButtonLabel || ('SOFT_PURGE.CONFIRM_BUTTON' | translate) }}
        }
    </button>
</div>
